import { FundingHistoryTable } from "./FundingHistoryTable";

export default FundingHistoryTable;
